import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { getProfile } from "../../reducers/commonReducer";

const schema = yup.object().shape({
  newpassword: yup.string().required('Please Provide New Password.'),
  password: yup.string().required('Please Provide Old Password.'),
});

function ProfileAction(props) {
  const dispatch = useDispatch();
  const {api} = props;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant={'success'} className="float-right" onClick={handleShow}>
      <i className="bi bi-pen-fill"></i>
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title>Update Profile</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values, { resetForm }) => {
            await dispatch(api(values));
            resetForm({ values: "" });
            dispatch(getProfile())
            setShow(false)
          }}
          initialValues={{
            newpassword:'',
            password:''
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            errors,
          }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3 mt-3">
                <Col md={6}>
                <Form.Group >
                    <Form.Label>Old Password</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Old Password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      isInvalid={!!errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group >
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter New Password"
                      name="newpassword"
                      value={values.newpassword}
                      onChange={handleChange}
                      isInvalid={!!errors.newpassword}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.newpassword}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit">
                  Submit
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default ProfileAction;
